import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {lightTheme} from '@components/@theme/lightTheme';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

interface AvatarPointPopperProps {
  open: boolean;
  anchorEl: any;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const AvatarPointPopper: React.FC<AvatarPointPopperProps> = ({
  anchorEl,
  children,
  open,
  onMouseEnter,
  onMouseLeave,
}) => {
  const [arrowRef, setArrowRef] = useState<SVGSVGElement | null>(null);
  const {arrow, paperHoverPopup} = useStyles(lightTheme);
  return (
    <Popper
      anchorEl={anchorEl.current}
      open={open}
      transition
      placement="top"
      disablePortal={false}
      modifiers={{
        flip: {
          enabled: true,
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
        },
        arrow: {
          enabled: true,
          element: arrowRef,
        },
      }}>
      {({TransitionProps}) => {
        return (
          <Fade {...TransitionProps} timeout={350}>
            <Paper
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              className={paperHoverPopup}>
              {children}
              <ArrowDropDownIcon className={arrow} ref={setArrowRef} />
            </Paper>
          </Fade>
        );
      }}
    </Popper>
  );
};

const useStyles = makeStyles(theme => ({
  paperHoverPopup: {
    marginBottom: 10,
    padding: theme.spacing(2),
  },
  arrow: {
    overflow: 'hidden',
    position: 'absolute',
    width: '2em',
    height: '1.8em',
    boxSizing: 'border-box',
    color: 'white',
    left: 'calc(50% - 1em)',
    bottom: '-14px',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      boxShadow: theme.shadows[3],
      backgroundColor: 'red',
      transform: 'rotate(45deg)',
    },
  },
}));
